import {
  createElementPropsSDKFactory,
  toJSONBase,
  composeSDKFactories,
  clickActionSDKFactory,
  unsupportedCurrentItemPropsSDKFactory,
  unsupportedPlayablePropsSDKFactory,
} from '@wix/editor-elements-corvid-utils';
import { createComponentSDKModel } from '@wix/editor-elements-integrations/corvid';
import type { IProGallerySDKFactory, WixSDKItems } from '../ProGallery.types';
import { onItemClickSDKFactory } from './factories/onItemClick';
import { onCurrentItemChangedSDKFactory } from './factories/onCurrentItemChanged';
import { onGalleryNavigationStartSDKFactory } from './factories/onGalleryNavigationStart';
import { onGetMoreItemsSDKFactory } from './factories/onGetMoreItems';
import { galleryNavigationSDKFactory } from './factories/galleryNavigation';

const proGallerySDKFactory: IProGallerySDKFactory = api => {
  const { props, metaData, setProps, getSdkInstance } = api;

  return {
    get items(): WixSDKItems {
      return props.wixSDKItems || [];
    },
    set items(items: WixSDKItems) {
      if (!items || items.length === 0) {
        setProps({ wixSDKItems: [], itemsSrc: 'organizeMedia' });
      }
      setProps({ wixSDKItems: items, itemsSrc: 'wixSDK' });
    },
    get showNavigationButtons() {
      return !!props.showArrows;
    },
    set showNavigationButtons(showNavigationButtons) {
      setProps({ showArrows: showNavigationButtons });
    },
    get galleryCapabilities() {
      return {
        isPlayable: false,
        hasCurrentItem: true,
        hasNavigationButtons: true,
        supportsAllMediaTypes: false,
        isAnimatable: true,
      };
    },
    get type() {
      return '$w.Gallery' as const;
    },
    set manualStyleParams(manualStyleParams: object) {
      setProps({ manualStyleParams });
    },
    get manualStyleParams() {
      return props.manualStyleParams || {};
    },
    toJSON() {
      const { clickAction, items } = getSdkInstance();
      return {
        ...toJSONBase(metaData),
        clickAction,
        items,
        type: '$w.Gallery',
      };
    },
  };
};

const elementPropsSDKFactory = createElementPropsSDKFactory();

export const sdk = composeSDKFactories([
  elementPropsSDKFactory,
  clickActionSDKFactory,
  unsupportedPlayablePropsSDKFactory,
  onItemClickSDKFactory,
  unsupportedCurrentItemPropsSDKFactory, // This must be before the onCurrentItemChangedSDKFactory to be overriden with the new implementation
  onCurrentItemChangedSDKFactory,
  proGallerySDKFactory,
  onGetMoreItemsSDKFactory,
  galleryNavigationSDKFactory,
  onGalleryNavigationStartSDKFactory,
]);

export default createComponentSDKModel(sdk);
